import React from 'react';
import * as S from './customLTRow.styled';

type Props = {
    children: React.ReactNode;
    style?: React.CSSProperties;
    id?: string;
    onClick?: () => void;
    flexStart?: boolean;
    wrapperStyle?: React.CSSProperties;
};

const CustomLTRow = React.forwardRef<HTMLDivElement, Props>(
    ({ children, style, id, onClick, flexStart, wrapperStyle }: Props, ref) => {
        return (
            <S.Row
                ref={ref}
                id={id}
                style={{
                    ...style,
                }}
                onClick={onClick}
                hasCursor={onClick ? true : false}
            >
                <S.Wrapper flexStart={!!flexStart} style={wrapperStyle}>
                    {children}
                </S.Wrapper>
            </S.Row>
        );
    }
);

export { CustomLTRow };
